import { FlowType } from "@redotech/redo-model/return-flow";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { ProductTypeState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/product-type";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { memo, useMemo, useState } from "react";

export const ProductTypeDetails = memo(function ProductTypeDetails({
  state,
  setState,
  disabled,
  flowType,
}: ConditionTypeDetailsProps<ProductTypeState>) {
  const [inputValue, setInputValue] = useState("");

  const tags = useMemo(
    () => state.map((tag) => ({ text: tag, color: "gray" as const })),
    [state],
  );

  const description =
    flowType === FlowType.FINALIZE_RETURN ||
    flowType === FlowType.FINALIZE_CLAIM
      ? "Product types to search for in all selected items"
      : undefined;

  return (
    <RedoTagInputField
      delimiters={["newline"]}
      description={description}
      inputValue={inputValue}
      label="Product type"
      placeholder="Type and press Enter to add"
      setInputValue={setInputValue}
      setTags={setState}
      size="sm"
      state={disabled ? "disabled" : "default"}
      tags={tags}
    />
  );
});
